import { Event, Component, EventEmitter, h, JSX } from '@stencil/core';

@Component({
  tag: 'app-notification',
  shadow: false,
})
export class AppNotification {
  @Event() belimoNotificationClose: EventEmitter<string>;
  public render(): JSX.Element {
    return (
      <div class="notification">
        <div class="notification__close" onClick={() => this.belimoNotificationClose?.emit('') }>
          <belimo-svg-sprite svgId={'x'}/>
        </div>
        <div class="notification__text">
          <h3>
            <slot name="header" />
          </h3>
          <slot />
        </div>
      </div>
    )
  }
}
